var map = {
	"./404.svg": "a14a",
	"./bug.svg": "1779",
	"./captcha.svg": "08e8",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide.svg": "6683",
	"./icon-audio-play.svg": "2534",
	"./icon-audio-start.svg": "18ad",
	"./icon-audio-stop.svg": "01f0",
	"./icon-audio.svg": "adfe",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./keDOC.svg": "e831",
	"./kePDF.svg": "7579",
	"./kePPT.svg": "0f4a",
	"./keVIDEO.svg": "27a8",
	"./keXLS.svg": "9220",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./picture.svg": "b6c6",
	"./praise.svg": "d585",
	"./qq.svg": "1430",
	"./search.svg": "8e8d",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./statisticSreen/screen-mid-list-1.svg": "602e",
	"./statisticSreen/screen-mid-list-2.svg": "b74f",
	"./statisticSreen/screen-mid-list-3.svg": "b293",
	"./statisticSreen/screen-mid-list-4.svg": "b19f",
	"./statisticSreen/screen-mid-list-5.svg": "32ba",
	"./statisticSreen/screen-platform-1.svg": "ce26",
	"./statisticSreen/screen-platform-2.svg": "2b1f",
	"./statisticSreen/screen-platform-3.svg": "62d9",
	"./statisticSreen/screen-platform-4.svg": "5b38",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./upload-class-course.svg": "54ed",
	"./upload-class-doc.svg": "3f20",
	"./upload-class-mp4.svg": "103e",
	"./upload-class-ppt.svg": "3361",
	"./user.svg": "b3b5",
	"./warning.svg": "7e6f",
	"./wechat.svg": "80da",
	"./zhuye.svg": "f88c",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e81";